let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("38kTe")).then(() => parcelRequire('i5FAK'));